import { render } from "./RoomMap.vue?vue&type=template&id=70991a76&scoped=true"
import script from "./RoomMap.vue?vue&type=script&lang=js"
export * from "./RoomMap.vue?vue&type=script&lang=js"

import "./RoomMap.vue?vue&type=style&index=0&id=70991a76&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70991a76"]])

export default __exports__